/**
 * A list of stacks the user owns
 * @module Stacks
 * @category Display Components
 */

import { CreateNewStack, ShowStacks } from "../../state/stackAtoms";
import { StyledDialogPanel, measures } from "@quickpoint.me/shared";

import { EditableFile } from "./EditableFile";
import FileTree from "./FileTree";
import { IsInPortrait } from "../../state/selectors";
import { StackCfKeysSelector } from "../../state/stackSelectors";
import { StacksHeader } from "./StacksHeader";
import groupByFolder from "./groupByFolder";
import styled from "styled-components";
import { useRecoilValue } from "recoil";

const StyledStacks = styled.div`
  display: grid;
  height: 100%;
  /* header floor: 48px pills + air */
  grid-template-rows: max(11%, 68px) auto 1fr;
  grid-template-columns: 1fr;
  grid-template-areas:
    "title"
    "files";
 
`;

const StyledNewStory = styled.div<{ $isInPortrait: boolean }>`
  border-inline: 1px solid ${(props) => props.theme.navigationFrame};
  border-block-start: 1px solid ${(props) => props.theme.navigationFrame};
  margin-inline: ${(props) =>
		props.$isInPortrait
			? measures.dialogPanel.portrait.margin
			: measures.dialogPanel.landscape.margin};
  margin-block-start: ${(props) =>
		props.$isInPortrait
			? measures.dialogPanel.portrait.margin
			: measures.dialogPanel.landscape.margin};
`;

const Stacks = (): JSX.Element => {
	const createNewStack = useRecoilValue(CreateNewStack);
	const isInPortrait = useRecoilValue(IsInPortrait);
	const showStacks = useRecoilValue(ShowStacks);
	const stackCfKeys = useRecoilValue(StackCfKeysSelector);

	const fileTree = groupByFolder(stackCfKeys);
	return (
		<StyledDialogPanel
			$show={showStacks}
			$isInPortrait={isInPortrait}
			data-testid="stories"
			id="stories"
			className="styled-dialog-panel"
		>
			<StyledStacks className="styled-stacks">
				<StacksHeader />
				{createNewStack && (
					<StyledNewStory $isInPortrait={isInPortrait}>
						<EditableFile key="newStack" stackCfKey="newStack" />
					</StyledNewStory>
				)}
				<FileTree
					key="fileTreeRoot"
					fileTree={fileTree}
					showStacks={showStacks}
				/>
			</StyledStacks>
		</StyledDialogPanel>
	);
};

export default Stacks;
